export default __webpack_public_path__ + "static/media/logo.221f51f6.svg";